import React from 'react';
interface NoticeLink {
  label: string;
  href: string;
}
const LINKS: NoticeLink[] = [{
  label: 'Información oficial sobre cosméticos',
  href: 'https://www.argentina.gob.ar/anmat/regulados/cosmeticos'
}, {
  label: 'Consultar habilitación de establecimientos mediante Declaración Jurada',
  href: 'https://www.argentina.gob.ar/node/492971'
}];

/**
 * Bloque informativo discreto, inmediatamente antes del footer. Tipografía más
 * chica que el contenido comercial y fondo suave de la misma paleta: informa
 * sin competir con los CTA.
 */
export function LegalNotice() {
  return <section id="informacion-importante" className="bg-cream pb-9 pt-3 sm:pb-12 sm:pt-5" data-id="element-164" data-mp="218w1bvz848xr">
      <div className="mx-auto max-w-md px-5 sm:max-w-2xl" data-id="element-165" data-mp="268s8g437wghj">
        <div className="rounded-2xl bg-sand px-4 py-4 sm:px-5 sm:py-5" data-id="element-166" data-mp="26ad2ztpj7zfe">
          <h2 className="font-display text-[0.62rem] font-bold uppercase tracking-editorial text-taupe" data-id="element-167" data-mp="2b8wndpoh935n">
            Información importante
          </h2>

          <p className="mt-2 font-sans text-[0.74rem] leading-relaxed text-taupe" data-id="element-168" data-mp="1kiyssflz7uqb">
            Este es un material educativo sobre elaboración artesanal de jabones de glicerina. Las
            fórmulas y contenidos incluidos no constituyen por sí mismos una habilitación para
            fabricar o comercializar productos cosméticos.
          </p>
          <p className="mt-1.5 font-sans text-[0.74rem] leading-relaxed text-taupe" data-id="element-169" data-mp="16kh8ysz6z2do">
            Si decidís comercializar los productos que elabores, deberás verificar y cumplir
            previamente las habilitaciones, requisitos sanitarios y demás normativa aplicable en tu
            jurisdicción.
          </p>
          <p className="mt-1.5 font-sans text-[0.74rem] leading-relaxed text-taupe" data-id="element-170" data-mp="1tgr99n3fp8fa">
            Si estás en Argentina, podés consultar la información y los trámites vigentes
            directamente en ANMAT.
          </p>

          <ul className="mt-2.5 space-y-1" data-id="element-171" data-mp="2h8ybv3zr6bn5">
            {LINKS.map(link => <li key={link.href} data-id="element-172" data-mp="2h6vf8143hk9g">
                <a href={link.href} target="_blank" rel="noreferrer" className="font-sans text-[0.74rem] font-semibold text-gold-deep underline decoration-gold/40 underline-offset-2 transition-colors duration-200 ease-out hover:text-charcoal focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-173" data-mp="faw97idu5y9b">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}